/**
 * Credential codes printed on customer tickets. Never use the person's name.
 * Cashiers: CAJ{id}. Floor sales (preventa / vendedor): VND{id}.
 */

export function normalizeStaffCode(raw) {
    const upper = String(raw || '').trim().toUpperCase();
    const match = upper.match(/^(VND|CAJ)0*(\d+)$/);
    if (!match) return '';
    const id = parseInt(match[2], 10);
    if (!Number.isInteger(id) || id < 1) return '';
    return `${match[1]}${id}`;
}

export function codigoPersonal(user) {
    const id = Number(user?.id);
    if (!Number.isInteger(id) || id < 1) return '';
    const role = Number(user.role ?? user.tipo_usuario_id);
    if (role === 5 || user.cajero === true) return `CAJ${id}`;
    if (role === 1 || role === 2) return `VND${id}`;
    return '';
}
